<template>
  <div :class="fadeClasses" class="handshake">
    <img
      class="man man-left"
      alt=""
      draggable="false"
      :src="require('@/assets/images/handshake/man-left.svg')"
    />
    <img
      class="man man-right"
      alt=""
      draggable="false"
      :src="require('@/assets/images/handshake/man-right.svg')"
    />
    <div class="handshake-circle"></div>
  </div>
</template>

<script>
import { Expo, Power1, TimelineMax } from 'gsap'
import { mediaQueryMixin, fadeMixin } from '@/mixins'

export default {
  name: 'Handshake',
  mixins: [mediaQueryMixin, fadeMixin],
  mounted () {
    const scene = this.$scrollmagic.scene({
      triggerElement: '.handshake'
    })

    const timeline = new TimelineMax()
      .fromTo('.man-left', 2, {
        x: -100
      }, {
        x: 0,
        ease: Expo.easeOut
      }, 0)
      .fromTo('.man-right', 2, {
        x: 100
      }, {
        x: 0,
        ease: Expo.easeOut
      }, 0)
      .to('.handshake-circle', 1, {
        ease: Power1.easeNone,
        opacity: 1,
        scale: 10
      }, 1.5)

    this.$scrollmagic.addScene(
      scene.setTween(timeline)
    )
  }
}
</script>

<style lang="scss" scoped>
.handshake {
  width: 300px;
  position: relative;
  margin: 100px auto;
  text-align: center;
}

.man {
  height: 220px;
  z-index: 2;
  position: relative;
}

.handshake-circle {
  width: 246px;
  height: 246px;
  border-radius: 50%;
  background-color: $c-red;
  position: absolute;
  bottom: 20px;
  left: 0;
  right: 0;
  margin: 0 auto;
  transform: scale(0);
}
</style>
